import React from 'react';

const Terms = () => {
  return (
    <div className="bg-gray-50 py-16">
      <div className="container-custom">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">Terms of Service</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Last Updated: April 24, 2024
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 mb-16">
          <div className="max-w-5xl mx-auto">
            <div className="prose prose-lg max-w-none prose-headings:text-primary prose-headings:font-bold prose-headings:mt-8 prose-p:text-gray-700 prose-li:text-gray-700 prose-li:marker:text-primary">
            <div className="bg-gradient-to-r from-primary/10 via-secondary/10 to-[#FFC600]/10 p-6 rounded-lg mb-8 border-l-4 border-[#FFC600] shadow-sm">
              <h3 className="text-xl font-bold text-primary mb-2">Welcome to Sportify!</h3>
              <p className="text-gray-700">
                These Terms govern your use of Sportify, our platform that connects you with multiple gym facilities. By using our services, you agree to these Terms. Please read them carefully as they contain important information about your legal rights, remedies, and obligations.
              </p>
            </div>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">1</span>
              Acceptance of Terms
            </h2>
            <p>
              By creating a Sportify account, whether through a mobile device, mobile application, or computer (collectively, the "Platform"), you agree to be bound by these Terms. If you do not accept and agree to be bound by all of the terms of this Agreement, please do not use the Platform.
            </p>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">2</span>
              Platform Description
            </h2>
            <p>
              Sportify provides a platform that enables users to discover and book fitness classes across Egypt. We do not own, operate, or control any of the fitness facilities listed on our platform. Sportify is not responsible for the quality, safety, or legality of any fitness class or facility available on the platform.
            </p>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">3</span>
              Eligibility
            </h2>
            <p>
              You must be at least 18 years of age to create an account on Sportify and use the Service. By creating an account and using the Service, you represent and warrant that:
            </p>
            <ul className="space-y-2">
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>You are at least 18 years of age.</span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>You can form a binding contract with Sportify.</span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>You are not a person who is barred from using the Service under the laws of Egypt or any other applicable jurisdiction.</span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>You will comply with these Terms and all applicable local, state, national, and international laws, rules, and regulations.</span>
              </li>
            </ul>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">4</span>
              Account Registration
            </h2>
            <p>
              To use Sportify, you must create an account with accurate information and safeguard your credentials. You are responsible for all activities under your account and for maintaining the confidentiality of your login credentials. You agree to immediately notify Sportify of any unauthorized use of your account or any other breach of security.
            </p>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">5</span>
              Booking and Cancellation Policy
            </h2>
            <p>
              When you book a class through Sportify, you agree to the following:
            </p>
            <ul className="space-y-2">
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>You must arrive at the fitness facility at least 10 minutes before the class starts.</span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>You may cancel a booking up to 6 hours before the scheduled start time for a full credit refund.</span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>Cancellations made less than 6 hours before the class starts will result in a forfeiture of the credits used for the booking.</span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>Repeated no-shows may result in account restrictions or termination.</span>
              </li>
            </ul>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">6</span>
              Credit Purchases & Subscriptions
            </h2>
            <p>
              Sportify lets you purchase credits via one-time top-ups or through monthly subscriptions at a discounted rate. Credits are used to book fitness classes. By purchasing credits or a subscription, you agree to the following:
            </p>
            <ul className="space-y-2">
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>All payments are processed through secure third-party payment processors.</span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>Individual credit purchases are non-refundable once used.</span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>Credits from one-time purchases expire 3 months after the date of purchase.</span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>Subscription credits refresh monthly and do not roll over to the next month.</span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>You may cancel a subscription at any time, effective at the end of the current billing cycle.</span>
              </li>
            </ul>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">7</span>
              Limitation of Liability
            </h2>
            <p>
              To the fullest extent permitted by applicable law, in no event shall Sportify, its affiliates, employees, licensors, or service providers be liable for any indirect, consequential, exemplary, incidental, special, punitive, or enhanced damages arising out of or in connection with your use of the Service.
            </p>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">8</span>
              Indemnification
            </h2>
            <p>
              You agree to indemnify, defend, and hold harmless Sportify and its officers, directors, employees, and agents from any and all claims, liabilities, damages, losses, costs, expenses, fees arising from or relating to:
            </p>
            <ul className="space-y-2">
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>Your use or misuse of the Platform.</span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>Your violation of these Terms.</span>
              </li>
              <li className="flex items-start">
                <span className="inline-flex items-center justify-center w-5 h-5 mr-2 mt-1 rounded-full bg-[#FFC600]/20 text-[#FFC600] text-xs">✓</span>
                <span>Your violation of any rights of any other person or entity.</span>
              </li>
            </ul>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">9</span>
              Modifications to Terms
            </h2>
            <p>
              Sportify reserves the right to modify these Terms at any time. We will provide reasonable advance notice of any material changes by posting the revised Terms on our Platform. Your continued use of the Platform after the effective date of the revised Terms constitutes your acceptance of the revised Terms.
            </p>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">10</span>
              Termination
            </h2>
            <p>
              Sportify may terminate or suspend your account at any time without notice if we believe that you have violated these Terms. Upon termination, your right to use the Platform will immediately cease.
            </p>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">11</span>
              Governing Law
            </h2>
            <p>
              These Terms are governed by and construed in accordance with the laws of Egypt, without giving effect to any principles of conflicts of law.
            </p>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">12</span>
              Cancellation & Refund Policy for Credits & Subscriptions
            </h2>
            <p>
              For credits purchases and subscription payments, you may cancel a class booking up to 12 hours before the scheduled start time and have the deducted credits returned to your wallet. Cancellations made within 12 hours or for no-shows are non-refundable. Refund requests for top-up credits or subscription fees will be considered only under exceptional circumstances where no classes have been booked and credits remain unused. Please contact customer support for refund inquiries.
            </p>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">13</span>
              Location Services
            </h2>
            <p>
              Our app uses your location to display distances to gym facilities and support check-ins. Location permission is essential for the proper functioning of certain features.
            </p>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">14</span>
              Notifications & Updates
            </h2>
            <p>
              We send notifications to confirm bookings, update payment statuses, and alert you about promotions and important updates.
            </p>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">15</span>
              Third-Party Sites & Services
            </h2>
            <p>
              Sportify may link to third-party sites or services. We do not guarantee their quality, and any interaction is at your own risk.
            </p>

            <h2 className="flex items-center">
              <span className="flex items-center justify-center w-8 h-8 mr-3 rounded-full bg-primary text-white text-sm font-bold shadow-[0_0_0_2px_rgba(255,198,0,0.3)]">16</span>
              Contact Information
            </h2>
            <p>
              If you have any questions about these Terms, please contact us at contact@sportify.eg.
            </p>

            <div className="bg-gradient-to-r from-[#FFC600]/5 to-[#FFC600]/10 p-6 rounded-lg mt-10 text-center border border-[#FFC600]/30 shadow-sm">
              <p className="text-xl font-medium text-gray-800 italic">
                Thank you for choosing Sportify. <span className="text-[#FFC600] font-bold">Enjoy seamless access to fitness classes and a healthier lifestyle!</span>
              </p>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;